import { createSelector } from 'reselect';
import get from 'lodash/get';

import { initialState } from './reducer';

const selectArtistsDomain = state => state.Artists || initialState;

const selectArtists = () => createSelector(selectArtistsDomain, subState => get(subState, 'artistsList'));

export { selectArtists };
